import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
 
export const SearchFieldTheme = {
    LIGHT: '',
    DARK: 'input-dark',
}

const SearchField = React.forwardRef((props, ref) => {
    const [value] = useState( props.value || undefined)

    const {
        
        placeholder,
        className,
        theme,
        // children,
        disabled,
        onChange,
        onClickClear,
        name,
        ariaLabel,
        autocomplete,
        id
    } = props
    const parentClass = classNames(
        'inputSearch',
        // 'searchField',
        // 'icon-search',
        {'searchField-dark' :  theme === SearchFieldTheme.DARK},
        className,
    )

    const classProps = classNames(
        '',
        theme,
    )

    return (
        <label className={parentClass}>
            {/* {children && 
                <label htmlFor="">{children}</label>
            } */}
            <input
                ref={ref}
                className={classProps} 
                type="search" 
                value={value} 
                placeholder={placeholder} 
                disabled={disabled}
                onChange={onChange}
                name={name}
                aria-label={ariaLabel}
                autoComplete={autocomplete}
                id={id}
            />
            {
                disabled  !== true && onClickClear &&
                    <span className="fieldClear icon-close" onClick={onClickClear}></span>
            }
        </label>
    )
})

SearchField.propTypes = {
    placeholder: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    theme: PropTypes.string,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    onClickClear: PropTypes.func,
    name: PropTypes.string,
    ariaLabel: PropTypes.string,
    autocomplete: PropTypes.string,
}
SearchField.defaultProps = {
    placeholder: 'Buscar',
    className: '',
    // value: '',
    theme: SearchFieldTheme.LIGHT,
    // children: '',
    disabled: false,
    onChange: ()=>{},
    // onClickClear: () =>{},
    // name: ''
    ariaLabel: 'Buscar',
    autocomplete: 'off',
}

export default memo(SearchField)
